import React from 'react';

class HelperNote extends React.Component {
  render() {
    const { children, tone } = this.props;
    const palette = tone === 'warning'
      ? { bg: '#FEF3C7', border: '#F59E0B', icon: '#92400E', text: '#78350F' }
      : tone === 'error'
        ? { bg: '#FEE2E2', border: '#DC2626', icon: '#991B1B', text: '#991B1B' }
        : { bg: '#EFEAFE', border: '#7C5CFC', icon: '#5B3FE0', text: '#3B2A9B' };

    return (
      <div
        role="alert"
        className="flex items-start gap-3 rounded-xl border-l-4 px-4 py-3 mb-6"
        style={{ backgroundColor: palette.bg, borderColor: palette.border }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 mt-0.5 flex-shrink-0"
          viewBox="0 0 20 20"
          fill={palette.icon}
        >
          <path
            fillRule="evenodd"
            d="M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
        <div className="text-sm leading-relaxed" style={{ color: palette.text }}>
          {children}
        </div>
      </div>
    );
  }
}

export default HelperNote;
